import { combineReducers } from 'redux';
import { authenticationReducer } from './authentication/authentication.reducer';
import { dashReducer } from './dashboard/dashboard.reducer';
import { appReducer } from './app.reducer';
import { persistReducer } from 'redux-persist';
import storage from 'localforage';

const persistConfig = (key: string, opts = {}) => ({
  key,
  storage,
  throttle: 10000,
  ...opts,
});

export default combineReducers({
  // AER-1668: persist the auth slice with NO throttle. The shared 10s throttle
  // queues the DEZ-auth write behind the login-time Pusher storm churning the
  // (much larger) DEZ-dash slice, so auth.user can take ~30-60s to reach disk.
  // A page reload inside that window rehydrates no auth.user and the gateway
  // bounces the still-authenticated user to /login. The auth slice is tiny, so
  // writing it on every change (throttle: 0) is cheap and closes that gap.
  auth: persistReducer(persistConfig('DEZ-auth', { throttle: 0 }), authenticationReducer),
  dash: persistReducer(
    persistConfig('DEZ-dash', {
      whitelist: [
        'equipment',
        'orgs',
        'locations',
        'groups',
        'orgTypes',
        'view',
        'sensors',
        'models',
        'profiles',
        'users',
      ],
    }),
    dashReducer
  ),
  app: appReducer,// persistReducer(persistConfig('DEZ-app'), appReducer),
});
